import { By } from 'selenium-webdriver';
import { DriverLike, register } from '@oracle/oraclejet-webdriver';
import { RadiosetWebElement } from './RadiosetWebElement';
export { RadiosetWebElement };

/**
 * Retrieve an instance of [RadiosetWebElement](../classes/RadiosetWebElement.html).
 * @example
 * ```javascript
 * import { findRadioset } from '@oracle/oraclejet-core-pack/webdriver';
 * const el = await findRadioset(driver, By.id('my-oj-c-radioset'));
 * ```
 * @param driver A WebDriver/WebElement instance from where the element will be
 * searched. If WebDriver is passed, the element will be searched globally in the
 * document. If WebElement is passed, the search will be relative to this element.
 * @param by The locator with which to find the element
 */
export async function findRadioset(driver: DriverLike, by: By): Promise<RadiosetWebElement> {
  const webEl = await driver.findElement(by);
  // Check that the element is of type RadiosetWebElement
  if (!(webEl instanceof RadiosetWebElement)) {
    const tagName = await webEl.getTagName();
    let supplemental = '';
    if (webEl.constructor.name === 'RadiosetWebElement') {
      supplemental = 'You likely have multiple installations of this package.';
    }
    throw Error(
      `findRadioset(${by}) created ${webEl.constructor.name} for <${tagName}>, but expected ${RadiosetWebElement.name}. ${supplemental}`
    );
  }
  return webEl;
}

register('oj-c-radioset', RadiosetWebElement);
